// extracted by mini-css-extract-plugin
export var active = "product-page-module--active--e79d9";
export var addToCartStyle = "product-page-module--addToCartStyle--ede77";
export var breadcrumb = "product-page-module--breadcrumb--f2a79";
export var calcBody = "product-page-module--calcBody--42f28";
export var calcWrap = "product-page-module--calcWrap--75242";
export var calcimage = "product-page-module--calcimage--2f198";
export var calculatorDrop = "product-page-module--calculatorDrop--be259";
export var calculatorWrapper = "product-page-module--calculator-wrapper--56ef8";
export var container = "product-page-module--container--631bb";
export var gatsbyImageWrapper = "product-page-module--gatsby-image-wrapper--b57ea";
export var header = "product-page-module--header--a2127";
export var horizontal = "product-page-module--horizontal--9213b";
export var labelFont = "product-page-module--labelFont--daa01";
export var metaSection = "product-page-module--metaSection--abb1d";
export var noImagePreview = "product-page-module--noImagePreview--66ea8";
export var optionalLay = "product-page-module--optionalLay--7dc1a";
export var optionsWrapper = "product-page-module--optionsWrapper--010c5";
export var priceValue = "product-page-module--priceValue--7e6e3";
export var priceWrap = "product-page-module--priceWrap--002b0";
export var productBox = "product-page-module--productBox--0cc77";
export var productDescription = "product-page-module--productDescription--6f570";
export var productDetailsWrap = "product-page-module--productDetailsWrap--ee80a";
export var productImageList = "product-page-module--productImageList--5215a";
export var productImageListItem = "product-page-module--productImageListItem--36efd";
export var productImageWrapper = "product-page-module--productImageWrapper--f0853";
export var recommend = "product-page-module--recommend--5d0b8";
export var scrollForMore = "product-page-module--scrollForMore--ffc5a";
export var selectVariant = "product-page-module--selectVariant--d99e3";
export var singleSelect = "product-page-module--singleSelect--def4e";
export var tagList = "product-page-module--tagList--8c708";
export var totalWrap = "product-page-module--totalWrap--10007";
export var vertical = "product-page-module--vertical--6386a";
export var visuallyHidden = "product-page-module--visuallyHidden--d60eb";